 import "../styles/events.css";
   import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

 
const EventsLoader = () => {
  
  

  return (
     
   <div>
           {[...Array(4)].map((_, index) => (
        
            <div   className="event-card loading-event-card">
              <div className="event-info">
                <p className="event-date">
                  <Skeleton width="200px" height="15px" />
                </p>
               <Skeleton width="40%" height="20px" style={{marginBottom:"10px"}}/>
                
                <Skeleton width="95%" height="10px" />
                <Skeleton width="100%" height="10px" />
                <Skeleton width="90%" height="10px" />
                 <Skeleton width="15%" height="30px" style={{marginTop:"10px"}} />

              </div>
              <div className="event-image">
                <Skeleton width="200px" height="100%" />
              </div>
            </div>
        ))}
   </div>

    
  );
};

export default EventsLoader;
